/**
 * policy模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const policy = {
  // 创建策略
  createPolicy(params) {
    return $http.post(`${global.API_URL}/sme/policy/create`,params);
  },
  // 编辑账户
  updatePolicy(params) {
    return $http.post(`${global.API_URL}/sme/policy/update`,params);
  },
  //策略列表分页
  pagePolicy(params) {
    return $http.post(`${global.API_URL}/sme/policy/page`,params);
  },
  //策略删除
  deletePolicy(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/delete`,param);
  },
  //立即备份目标
  backupTargetsPolicy(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/backupTargets`,param);
  },
  // 查询策略
  selectPolicy(id,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/select`,param);
  },
  //获取Region
  getRegions(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/getRegions`,param);
  },
  //开启或关闭Policy
  changeStatus(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/changeStatus`,param);
  },
  //补丁基准分页
  listPatchBaseline(params) {
    return $http.post(`${global.API_URL}/sme/policy/listPatchBaseline`,params);
  },
  //添加补丁基准
  createPatchBaseline(params) {
    return $http.post(`${global.API_URL}/sme/policy/createPatchBaseline`,params);
  },
  //补丁基准详情
  getPatchBaselineDetail(params) {
    return $http.post(`${global.API_URL}/sme/policy/getPatchBaselineDetail`,params);
  },
  //补丁页面和详情
  listPatch(params) {
    return $http.post(`${global.API_URL}/sme/policy/listPatch`,params);
  },
  //产品和优先级
  getPatchBaselineInfo(params) {
    return $http.post(`${global.API_URL}/sme/policy/getPatchBaselineInfo`,params);
  },
  //命令分页
  listCommands(params) {
    return $http.post(`${global.API_URL}/sme/policy/listCommands`,params);
  },
  //命令历史记录分页
  listHistoryCommands(params) {
    return $http.post(`${global.API_URL}/sme/policy/listHistoryCommands`,params);
  },
  //命令列表详情
  getCommandDetail(params) {
    return $http.post(`${global.API_URL}/sme/policy/getCommandDetail`,params);
  },
  //查看输出
  getCommandTargetInstanceOutput(params) {
    return $http.post(`${global.API_URL}/sme/policy/getCommandTargetInstanceOutput`,params);
  },
  //补丁监视器
  patchMonitor(params) {
    return $http.post(`${global.API_URL}/sme/policy/patchMonitor`,params);
  },
  //立即允许补丁
  runPatch(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/runPatch`,param);
  },
  //提醒时间
  getRemindTime(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/policy/getRemindTime`,param);
  }
}

export default policy;



// WEBPACK FOOTER //
// ./src/api/policy.js